import React, {useState} from 'react';
import {
    Grid,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Button,
} from '@material-ui/core';
import CircleIcon from '@mui/icons-material/Circle';

import Popup from './Popup';
import InputSearch from './InputSearch';

import {grey, green, red} from '@material-ui/core/colors';
import api from '../services/api';

export default function IPWebcamPicker({onSelect, open, onClose}) {
    const [webcams, setWebcams] = useState([]);
    const [page, setPage] = useState(0);
    const [limit, setLimit] = useState(20);
    const [total, setTotal] = useState(0);

    function findWebcams({search}) {
        (async () => {
            try {
                const result = await api.get('/device/list', {
                    params: {
                        search,
                        limit,
                        page,
                        type: ['ip-webcam'],
                    },
                });

                const {count, devices} = result.data;

                setWebcams(devices);
                setTotal(count);
            }
            catch (err) {
                console.log(err);
            }
        })();
    }

    return (
        <Popup
            openPopup={open}
            onClose={onClose}
        >
            <Grid container justify='center' alignItems='center'>
                <Grid item xs={12}>
                    <Typography
                        variant='h6'
                        style={{textAlign: 'center', color: grey[700]}}
                    >
                        Webcams
                    </Typography>
                </Grid>
                <Grid item spacing={5} xs={12}>
                    <InputSearch
                        textFieldProps={{
                            placeholder: 'Buscar…',
                        }}
                        request={findWebcams}
                        pagination={[page, limit]}
                    />
                </Grid>
                <Grid item xs={12} style={{marginBottom: 30, marginTop: 15}}>
                    <TableContainer component={Paper}>
                        <Table sx={{minWidth: 650}} aria-label="webcams">
                            <TableHead>
                                <TableRow>
                                    <TableCell align="center">#</TableCell>
                                    <TableCell align="center">Nome</TableCell>
                                    <TableCell align="center">Status</TableCell>
                                    <TableCell align="center">Local</TableCell>
                                    <TableCell align="center">Ações</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                            {webcams.map(webcam => (
                                <TableRow
                                    key={webcam.id}
                                    sx={{'&:last-child td, &:last-child th': {border: 0}}}
                                >
                                    <TableCell component="th" scope="row" align="center">
                                        {webcam.id}
                                    </TableCell>
                                    <TableCell align="center">{webcam.name}</TableCell>
                                    <TableCell align="center">
                                        <CircleIcon htmlColor={webcam.status ? green[700] : red[800]} />
                                    </TableCell>
                                    <TableCell align="center">{webcam?.place_devices?.name || 'Não definido'}</TableCell>
                                    <TableCell align="center">
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={() => onSelect(webcam)}
                                            disabled={!webcam.status}
                                        >
                                            Selecionar
                                        </Button>
                                    </TableCell>
                                </TableRow>
                            ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
                <Grid item xs={12} style={{textAlign: 'end'}}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => onClose()}
                    >
                        Fechar
                    </Button>
                </Grid>
            </Grid>
        </Popup>
    );
};
